<template>
  <div>
   <xContent />
   <!--  <codemirror class="CodeMirror"   
    ref="cm1" :options="getcmOptions()"
    v-model = "activeTmpContent" @keypress.enter="handleEnter" />
    <div>
      <VueMathjax :formula="formula" :options="customOptionstex"/>
      <VueMathjax :formula="formula2" :options="customOptions" />
      <v-layout row wrap>
        <v-flex xs4>
          <v-textarea v-model="formula"  background-color="light-blue" cols="30" rows="3" />  
        </v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs4>
          <v-textarea v-model="formula2" background-color="light-blue" cols="30" rows="3" />  
        </v-flex>
      </v-layout>
    </div>  -->
  </div>
</template>

<script>
// require styles
import {mapGetters} from 'vuex'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
// import * as es from '../../../../assets/editor_settings.js'
import { VueMathjax } from 'vue-mathjax'
import xContent from '../../components/jprcomponents/etype_xrw_content.vue'

export default {
  data() {
    return {
        activeTmpContent: 'my data',
        formula: '$$x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.$$',
        formula2: 'my eq ||sum_(i=1)^n i^3=((n(n+1))/2)^2[[1,2],[3,4]]||',

        customOptions: {
          asciimath2jax: {
            delimiters: [['||','||']]
          },
          tex2jax: {
            inlineMath: [["$", "$"], ["\\(", "\\)"]],//inline formula selector
            displayMath: [["$$", "$$"], ["\\[", "\\]"]],//In-paragraph formula selector
            skipTags: ["script", "noscript", "style", "textarea", "pre", "code", "a"]//Avoid certain tags
          }
        },
        customOptionstex: {
          displayAlign: 'center',
        }
    }
  },
    components: {
        codemirror,  
        VueMathjax,
        xContent
    },
  methods : {
      getcmOptions() {
        return  {
            tabSize: 4,
            lineNumbers: true,        
            viewportMargin : Infinity
        }
      },
      update() {
        this.content = this.contenthlp
      }
  }
}
</script>

<style>
.CodeMirror {
  border: 1px solid #000;
  height: auto;
}
</style>